import brightThemeJson from "@/components/expression/theme/corca-themes/bright-theme.json";
import bwContrastThemeJson from "@/components/expression/theme/corca-themes/bw-contrast-theme.json";
import bwLightThemeJson from "@/components/expression/theme/corca-themes/bw-light-theme.json";
import bwRegularThemeJson from "@/components/expression/theme/corca-themes/bw-regular-theme.json";
import contrastBrightThemeJson from "@/components/expression/theme/corca-themes/contrast-bright-theme.json";
import contrastLightThemeJson from "@/components/expression/theme/corca-themes/contrast-light-theme.json";
import contrastRegularThemeJson from "@/components/expression/theme/corca-themes/contrast-regular-theme.json";
import hintLightThemeJson from "@/components/expression/theme/corca-themes/hint-light-theme.json";
import lightThemeJson from "@/components/expression/theme/corca-themes/light-theme.json";
import outlineContrastThemeJson from "@/components/expression/theme/corca-themes/outline-contrast-theme.json";
import outlineLightThemeJson from "@/components/expression/theme/corca-themes/outline-light-theme.json";
import outlineRegularThemeJson from "@/components/expression/theme/corca-themes/outline-regular-theme.json";
import regularThemeJson from "@/components/expression/theme/corca-themes/regular-theme.json";

import type { NodeTheme } from "@/components/expression/theme/types";

export const outlineLightTheme = outlineLightThemeJson as NodeTheme;
export const outlineRegularTheme = outlineRegularThemeJson as NodeTheme;
export const outlineContrastTheme = outlineContrastThemeJson as NodeTheme;

export const lightTheme = lightThemeJson as NodeTheme;
export const regularTheme = regularThemeJson as NodeTheme;
export const brightTheme = brightThemeJson as NodeTheme;

export const bwLightTheme = bwLightThemeJson as NodeTheme;
export const bwRegularTheme = bwRegularThemeJson as NodeTheme;
export const bwContrastTheme = bwContrastThemeJson as NodeTheme;

export const contrastLightTheme = contrastLightThemeJson as NodeTheme;
export const contrastRegularTheme = contrastRegularThemeJson as NodeTheme;
export const contrastBrightTheme = contrastBrightThemeJson as NodeTheme;

export const hintLightTheme = hintLightThemeJson as NodeTheme;

export const themes: NodeTheme[] = [
  outlineLightTheme,
  outlineRegularTheme,
  outlineContrastTheme,

  lightTheme,
  regularTheme,
  brightTheme,

  bwLightTheme,
  bwRegularTheme,
  bwContrastTheme,

  contrastLightTheme,
  contrastRegularTheme,
  contrastBrightTheme,
];
